import { Link, Outlet } from "@tanstack/react-router";
import { List, Users, Zap, Link as LinkIcon } from "lucide-react";
import { UserMenu } from "@/components/UserMenu";
import { useRole } from "@/contexts/RoleContext";

export const AppShell = () => {
  const { actualRole } = useRole();

  return (
    <div className="min-h-screen bg-white text-gray-900">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm">
        <div className="mx-auto max-w-7xl px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
              <img src="/wpp-open-logo.png" alt="WPP Open" className="h-8" />
              <div>
                <p className="text-sm uppercase tracking-wide text-gray-500">Ford Creative</p>
                <h1 className="text-xl font-semibold text-gray-900">Content QC</h1>
              </div>
            </Link>

            <nav className="flex items-center gap-4">
              <Link
                to="/instant-analysis"
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 font-medium border border-gray-200 hover:text-wppBlue hover:bg-gray-100 hover:border-gray-300 transition-colors"
              >
                <Zap className="w-4 h-4" />
                Instant Analysis
              </Link>
              <Link
                to="/load-from-url"
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 font-medium border border-gray-200 hover:text-wppBlue hover:bg-gray-100 hover:border-gray-300 transition-colors"
              >
                <LinkIcon className="w-4 h-4" />
                Load from URL
              </Link>
              <Link
                to="/reports"
                className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 font-medium border border-gray-200 hover:text-wppBlue hover:bg-gray-100 hover:border-gray-300 transition-colors"
              >
                <List className="w-4 h-4" />
                Reports
              </Link>
              {actualRole === 'ADMIN' && (
                <Link
                  to="/users"
                  className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-700 font-medium border border-gray-200 hover:text-wppBlue hover:bg-gray-100 hover:border-gray-300 transition-colors"
                >
                  <Users className="w-4 h-4" />
                  Users
                </Link>
              )}
              <UserMenu />
            </nav>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};
